import * as Sentry from '@sentry/react';
import { isLocalhost } from 'shared-base';

if (!isLocalhost()) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [],
    environment: import.meta.env.MODE, // Capture current Vite environment

    // NOTE(Rok Kos): This is snippet is taken from Sentry dashboard to enable the replays. For now its at 1.0, when we are going to launch we need to go to 0.1
    replaysSessionSampleRate: 0.1, // 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
    beforeSend(event) {
      // Log error locally for debugging
      console.error('Sentry captured error:', event);

      // Allow reporting errors in development
      return event;
    },
  });
}
